import { LaravelResponse, keyToUrl } from "@dgs/core";
import axios, { AxiosRequestConfig } from "axios";
import { UserPreferencesShowResource, UserPreferencesUpdateRequest } from "../types/userPreferences";

const baseKey = ["user-preferences"];

export const userPreferencesService = {
	showKey: baseKey,
	show: (config?: AxiosRequestConfig) =>
		axios.get<LaravelResponse<UserPreferencesShowResource>>(keyToUrl(baseKey), config),
	update: (userPreferencesUpdateRequest: UserPreferencesUpdateRequest) =>
		axios.put<LaravelResponse<void>>(keyToUrl(baseKey), userPreferencesUpdateRequest),
};
